import { useFormContext } from 'react-hook-form';
import { MouseEvent } from 'react';
import { LocalizedText } from '@mews/framework';
import { Button, IconName, Stack, Typography } from '@optimus-web/core';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { CompaniesFormValues } from '../../../../../schemas';
import { RoutingRulesFormFields } from '../../../utils';
import { getSelectedCompaniesCount } from '../../../../../utils/companies';
import { CompaniesDialog } from './CompaniesDialog';

interface CompanySelectFieldProps {
    onClose: () => void;
    active: boolean;
    openDialog: () => void;
}

export const CompanySelectField = ({ onClose, active, openDialog }: CompanySelectFieldProps) => {
    const { watch } = useFormContext();
    const selectedCompanies: CompaniesFormValues = watch(RoutingRulesFormFields.companies());
    const selectedCompaniesCount = getSelectedCompaniesCount(selectedCompanies);

    const onDialogOpen = (e: MouseEvent) => {
        e.preventDefault();
        openDialog();
    };

    return (
        <>
            <Stack itemAlignment="center">
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    <LocalizedText textKey={TextKey.SelectedCount} substitutes={{ count: selectedCompaniesCount }} />
                </Typography>
                {UnicodeEntity.NoBreakSpace}
                <Button
                    icon={IconName.Edit}
                    onClick={onDialogOpen}
                    size="small"
                    type="submit"
                    data-test-id={DataTestId.RoutingRulesCompaniesEditButton}
                >
                    <LocalizedText textKey={TextKey.Edit} />
                </Button>
            </Stack>
            <CompaniesDialog active={active} onClose={onClose} />
        </>
    );
};
